module.exports = __webpack_public_path__ + "img/registry.9f548530.svg";